import React from 'react';
import { Link } from 'react-router-dom';
import MobileSidebar from './sidebar';

const HeaderAlt = () => {
  return (
    <header className="header sticky top-0 z-20 w-full !bg-[#012E33]">
      <div className="navbar-cont container !w-full flex items-center justify-between">
        <Link to="/" className="logo nav-logo-title !text-[30px] !text-[#ffffff] flex items-center">
          <img src="/images/icons/logo-new.svg" className="mr-[11px] h-[31px] w-12" alt="IAMAI logo" />
          IAMAI
        </Link>

        <nav className="nav-links flex gap-6 items-center">
          <Link to="/apply-as-vip" className="!text-white relative">
            Apply
            <span className="absolute -top-2 -right-4 bg-[#FC823E] text-white text-xs font-bold px-2 py-[2px] rounded-full">
              VIP!
            </span>
          </Link>

          <Link to="/tutor-crm" className="!text-white">Our Platform</Link>
          <Link to="/nexus-app" className="!text-white">Nexus</Link>
          <Link to="/about" className="!text-white">About</Link>
          <Link to="/contact" className="!text-white">Contact</Link>
        </nav>

        <div className="nav-button flex items-center gap-4">
          <Link
            to="/login"
            className="fredokaOne h-12 rounded-2xl border border-[#66CDCC] px-6 py-2 text-[#66CDCC]"
          >
            Login
          </Link>
          <MobileSidebar color="header-white" />
        </div>
      </div>
    </header>
  );
};

export default HeaderAlt;
